import { defaultConfig, DrumAdapter, DrumMessageAdapter } from './MidiDrumAdapter';
export class KeyboardDrumAdapter extends DrumAdapter {
    clock;
    keyMapping;
    messageAdapter;
    constructor(clock, keyMapping) {
        super();
        this.clock = clock;
        this.keyMapping = keyMapping;
        this.messageAdapter = new DrumMessageAdapter(clock, defaultConfig);
        window.addEventListener('keydown', this.handleKeyDown);
        window.addEventListener('keyup', this.handleKeyUp);
    }
    close() {
        window.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('keyup', this.handleKeyUp);
    }
    handleKeyDown = (event) => {
        const noteOn = {
            kind: 'noteon', note: this.keyMapping[event.key],
            timestamp: performance.now(),
            velocity: 0.8
        };
        const hit = this.messageAdapter.convertNoteOn(noteOn);
        if (hit.value > 0) {
            this.emit('hit', hit);
        }
    };
    handleKeyUp = (event) => {
        const noteOff = {
            kind: 'noteoff', note: this.keyMapping[event.key],
            timestamp: performance.now(),
            velocity: 0.8
        };
        const choke = this.messageAdapter.convertNoteOff(noteOff);
        if (choke.value > 0) {
            this.emit('choke', choke);
        }
    };
}
//# sourceMappingURL=KeyboardDrumAdapter.js.map